import React from "react";
import { BsCreditCard, BsEnvelopeOpen } from "react-icons/bs";
import { FiArrowRight } from "react-icons/fi";

import TourBalloon from "components/NewTour/TourBallon";
import { Button, Card, ContentCard, ContentWrap, Icon, Title } from "./styles";
import { useTour } from "hooks/useTour";

const cards = [
  {
    image: "static/card_debito_automatico.png",
    icon: BsCreditCard,
    title: "Débito automático",
    buttonText: "Cadastrar",
    to: "/debito-automatico",
  },
  {
    image: "static/card_boleto_digital.png",
    icon: BsEnvelopeOpen,
    title: "Preferências de Cobrança",
    buttonText: "Editar",
    to: "/preferencia-cobranca",
  },
];

const CTOS = (): JSX.Element => {
  const { showTour, tourStep, tourType } = useTour();

  return (
    <ContentCard showTour={tourStep === 9 && tourType === "home" && showTour}>
      <ContentWrap>
        {cards?.map((card) => {
          const IconCard = card.icon;
          return (
            <Card image={card?.image} key={card?.to}>
              <Icon>
                <IconCard />
              </Icon>
              <Title>{card?.title}</Title>
              <Button to={card.to}>
                <span>{card?.buttonText}</span>
                <FiArrowRight />
              </Button>
            </Card>
          );
        })}
        {showTour && tourStep === 9 && tourType === "home" && (
          <TourBalloon
            title="Acessos Rápidos"
            content="Através de um clique você poderá ter acesso à funcionalidade que desejar de forma fácil e rápida."
            position={{
              right: "0",
              top: "212px",
              arrowPosition: "top",
              maxWidth: 320,
            }}
          />
        )}
      </ContentWrap>
    </ContentCard>
  );
};

export default CTOS;
